import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';
import {
  applyAnalyticsPendingLoading,
  markAnalyticsFetchKey,
} from '../../utils/analyticsQuery';

export const getWebsiteTrafficGraphStats = createAsyncThunk(
  'websiteTrafficGraphStats/getWebsiteTrafficGraphStats',
  async ({ range = '30d', startDate = null, endDate = null, group_id }, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id = loginToken?.response?.user?.business_id;

      // Build query params based on whether custom dates are provided
      let queryParams = '';
      if (startDate && endDate) {
        // Custom date range
        queryParams = `from=${startDate}&to=${endDate}&range=custom`;
      } else {
        // Predefined range
        queryParams = `range=${range}`;
      }
      if (group_id) {
        queryParams += `&group_id=${encodeURIComponent(group_id)}`;
      }

      const response = await axios.get(
        `${ROOT_URL}/co-users/traffic-stats/${business_id}?${queryParams}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  data: null,
  lastFetchKey: null,
  currentRange: '30d'
};

const websiteTrafficGraphStatsSlice = createSlice({
  name: 'websiteTrafficGraphStats',
  initialState,
  reducers: {
    resetWebsiteTrafficGraphStatsState: (state) => {
      state.loading = false;
      state.error = null;
      state.data = null;
      state.lastFetchKey = null;
      state.currentRange = '30d';
    },
    setWebsiteTrafficCurrentRange: (state, action) => {
      state.currentRange = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWebsiteTrafficGraphStats.pending, (state, action) => {
        applyAnalyticsPendingLoading(state, action.meta?.arg);
        state.error = null;
      })
      .addCase(getWebsiteTrafficGraphStats.fulfilled, (state, action) => {
        state.loading = false;
        markAnalyticsFetchKey(state, action.meta?.arg);
        state.data = action.payload.data;
        state.error = null;
      })
      .addCase(getWebsiteTrafficGraphStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = null;
      });
  }
});

export const { resetWebsiteTrafficGraphStatsState, setWebsiteTrafficCurrentRange } = websiteTrafficGraphStatsSlice.actions;
export default websiteTrafficGraphStatsSlice.reducer;

